import { defineMessages } from 'react-intl';

export default defineMessages({
  SellerProfileHeaderYourProfile: {
    id: 'SellerProfileHeaderYourProfile',
    defaultMessage: 'Your profile',
  },
});
